import { Button, Col, Form, Input, Row } from "antd";
import moment from "moment";
import React from "react";
import { Translate } from "react-localize-redux";
import {
	DepositLimitSetButton,
	Description,
	MaximumDailyDepositLimitWrapper,
	Title,
} from "./elements";
import useController from "./useController";

const MaximumDailyDepositLimit = ({ user }) => {
	const {
		state: {
			isDepositLimitSet,
			depositLimitAmount,
			depositLimitStartDate,
			isSetting,
			isDeleting,
			isButtonDisabled,
		},
		handlers: { handleDepositLimit, handleFormValuesChange, handleDeleteDepositLimit },
		helpers: { AMOUNT_REGEX, form },
	} = useController({ user });

	return (
		<Translate>
			{({ translate }) => (
				<MaximumDailyDepositLimitWrapper>
					<Title>{translate("Maximum Daily Deposit Limit")}</Title>
					<Description>
						<p>{translate("Maximum Daily Deposit Limit Desc")}</p>
					</Description>

					{isDepositLimitSet ? (
						<>
							<DepositLimitSetButton>
								{translate("depositLimit.notice", {
									date: moment(depositLimitStartDate).format("DD.MM.YYYY, HH:mm"),
									amount: depositLimitAmount,
								})}
							</DepositLimitSetButton>
							<Button
								onClick={handleDeleteDepositLimit}
								loading={isDeleting}
								disabled={isDeleting}
								className="two-factor-auth-exclude-btn"
								style={{ marginTop: 10 }}>
								{translate("Remove Daily Deposit Limit")}
							</Button>
						</>
					) : (
						<Form
							form={form}
							onFinish={handleDepositLimit}
							onValuesChange={handleFormValuesChange}>
							<Row
								xs={24}
								gutter={10}>
								<Col xs={12}>
									<Form.Item
										label={translate("Daily Deposit Limit Amount")}
										name="depositLimitAmount"
										rules={[
											{
												required: true,
												message: translate("Please input amount!"),
												pattern: AMOUNT_REGEX,
											},
										]}>
										<Input
											type="number"
											min={1}
											step="0.01"
											placeholder={translate("Enter daily deposit limit")}
											disabled={isSetting}
										/>
									</Form.Item>
								</Col>
								<Col xs={12}>
									<Form.Item>
										<Button
											htmlType="submit"
											type="submit"
											loading={isSetting}
											className="two-factor-auth-exclude-btn"
											style={{
												opacity: form.getFieldValue("depositLimitAmount")
													? 1
													: 0.5,
											}}
											disabled={isButtonDisabled || isSetting}>
											{translate("Set Daily Deposit Limit")}
										</Button>
									</Form.Item>
								</Col>
							</Row>
						</Form>
					)}
				</MaximumDailyDepositLimitWrapper>
			)}
		</Translate>
	);
};

export default MaximumDailyDepositLimit;
